//Action Type constant for login signup workspace settings APIs
export const TENANT_USER_LOGIN_SIGNUP_API = {
	loginWithPassword: '/login-with-password',
	get2FAStatus: '/two-factor-authentication-status',
};

export const TENANTS = {
	myProfile: '/my-profile',
	employee: '/employee',
	profilePicture: '/display-picture',
};
